import {useState, useRef} from 'react';
import List from '@mui/material/List';
import { Typography, Box, Paper, Divider, Button } from '@mui/material';
import AppointmentsListItems from './AppointmentsListItems';

export default function UpcomingAppointmentsList({ pet = null, mode = 'pet', refreshRecommendedVisits = null }) {

  const [listEmpty, setListEmpty] = useState(true);
  const listRef = useRef();

  return(
      <Paper 
        elevation={3} 
        sx={{ 
          p: 2, 
          borderRadius: 2, 
        }}
      >
      <Typography variant="h6">Upcoming Appointments</Typography>
      <br />
      {listEmpty ? 
        <Divider variant="fullWidth" component="li">
          <Typography variant="caption" color="text.secondary">
            no upcoming appointments
          </Typography>
        </Divider>
      : null}
      <Box sx={{
        maxHeight: 300,
        overflow: "auto"
      }}>
        <List >
          <AppointmentsListItems
            pet={pet}
            mode={mode}
            upcoming={true}
            setListEmpty={setListEmpty}
            ref={listRef}
            refreshRecommendedVisits={refreshRecommendedVisits}
          />
        </List>
      </Box>
      {mode === 'pet' ?
        <Button 
          fullWidth
          variant="outlined" 
          color="primary"
          onClick={() => listRef.current.handleAppointmentCreate()}
          sx={{ mt: 1 }}
        >
          Create Appointment
        </Button>
      : null}
      </Paper>
  );
}